import { render, staticRenderFns } from "./AdsTable.vue?vue&type=template&id=60eb691e"
import script from "./AdsTable.vue?vue&type=script&lang=js"
export * from "./AdsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports